import { RequestLog } from '@engine/models'

interface EbolStatusBadgeProps {
  log: RequestLog
}

export const EbolStatusBadge = ({ log }: EbolStatusBadgeProps) => {
  const ebol = log.tenantResponse?.content

  if (!ebol?.status) {
    return <span className="text-xs opacity-50">N/A</span>
  }

  const statusLower = ebol.status.toLowerCase()
  let badgeClass = 'badge-neutral'
  let displayText = ebol.status

  if (statusLower === 'ok') {
    badgeClass = 'badge-success'
  } else if (statusLower === 'error') {
    badgeClass = 'badge-error'
    const errorType = ebol.errors?.[0]?.type
    if (errorType) {
      displayText = errorType
    }
  } else if (statusLower === 'pending') {
    badgeClass = 'badge-warning'
  }

  return <span className={`badge badge-sm ${badgeClass}`}>{displayText}</span>
}
